export var Spacing;
(function (Spacing) {
    Spacing[Spacing["Medium"] = 10] = "Medium";
})(Spacing || (Spacing = {}));
export const Border = {
    Size: {
        Small: 1,
    },
};
export var Radius;
(function (Radius) {
    Radius[Radius["XSmall"] = 4] = "XSmall";
    Radius[Radius["Small"] = 6] = "Small";
    Radius[Radius["Medium"] = 8] = "Medium";
    Radius[Radius["LargeMedium"] = 12] = "LargeMedium";
    Radius[Radius["Large"] = 16] = "Large";
})(Radius || (Radius = {}));
export const Size = {
    Inline: {
        width: 140,
        height: 64,
    },
    Full: {
        width: 288,
        height: 64,
    },
};
//# sourceMappingURL=Card.js.map